import { EditRealtyScreenContent } from "../../features/editRealty";

// Thin route wrapper — mirrors RealtyDetailScreen / RealtyHomeScreen /
// RealtySearchScreen / RealtySavedScreen. Per R6.1 STEP R6.1.2: route
// shell only. The .add-property-page.edit-property-page #Csection
// envelope + full content + fetch + ownership gating + mutations all
// live INSIDE the feature widget.

function RealtyEditScreen() {
  return <EditRealtyScreenContent />;
}

export default RealtyEditScreen;
